export const Color = {
  PRIMARY: '#A368BF',
  SECONDARY: '#C580E4',
  TERTIARY: '#D090ED',
};
